import React from 'react';
import HeaderCardContent from '../Reusable/HeaderCardContent/HeaderCardContent';
import AddQuickEmailCard from './AddQuickEmail/AddQuickEmailCard';

const QuickEmail = ({ refetch }) => {
  return (
    <>
      {/* <HeaderCardContent name={"Quick Email"} /> */}
      <AddQuickEmailCard refetch={refetch} />
    </>
  );
};

export default QuickEmail;
